export const PILOT = "Pilot"
export const FLIGHT_ATTENDANT = "Flight Attendant"
export const ENGINEER = "Engineer"
export const MANAGEMENT = "Manager"


/** WEBPACK FOOTER **
 ** ./src/components/person/types.js
 **/